const e = "Tarjetas de sellos", o = "Gastos de envío", a = "Otros cargos", n = "Cashback", i = "Métodos de pago", r = "Pagar", t = "Nivel", s = "Puntos", d = "Tarjeta de fidelización", c = "Premios", l = "Descuento", u = "Propina", p = "Total", m = "Subtotal", g = "Entregado", h = "Preparar", v = "Entrega", f = "En sala", L = "Para llevar", b = "Cargar más", y = "Guardar", k = "Nombre", P = "Apellidos", C = "Correo", T = "Cumpleaños", A = "Etiquetas", E = "Género", x = "Idioma", w = "Código postal", U = "bbb", I = "A domicilio", O = "A recoger", S = "Desconocido", M = "Teléfono", B = "Hoy", V = "Mañana", j = "Día", R = "Hora", D = "Llamar", H = "Invitado", N = "Inicia sesión o regístrate", z = "Uber", G = "Glovo", q = "Deliveroo", F = "Justeat", W = {
  "wallet.loading.errorTitle": "Se ha producido un error",
  "wallet.loading.error": "Intenta realizar la descarga de nuevo",
  "wallet.loading.android.success": "Guardado en Google Wallet",
  "wallet.loading.ios.success": "Guardado en Apple Wallet",
  "wallet.loading.ios": "Cargando en Apple Wallet",
  "wallet.loading.android": "Cargando en Google Wallet",
  stampCards: e,
  "stampCard.complete": "¡Felicidades! Has completado todos los ciclos disponibles.",
  "stampCard.cycleEnd": "Has conseguido un nuevo premio. ¡Gracias por visitarnos!",
  "stampCard.expired": "La tarjeta ha caducado",
  "stampCard.expirationLabel": "Caducidad:",
  "userOrders.empty": "Tu historial de pedidos esta vacio",
  "userOrders.info": "Selecciona un pedido para ver detalles",
  deliveryFee: o,
  defaultFeeName: a,
  "kioskLanding.outOfOrder.title": "Fuera de servicio",
  "kioskLanding.outOfOrder.subtitle": "No se aceptan pedidos en este momento. Consulta con un camarero para iniciar un pedido.",
  "kioskLanding.language.title": "Selecciona un idioma",
  "kioskLanding.service.title": "¿Dónde quieres tu pedido?",
  "kioskLanding.service.takeaway": "Para llevar",
  "kioskLanding.service.dineIn": "Comer aquí",
  "kioskLanding.service.otherLanguages": "Más idiomas",
  "kioskLanding.inactive.title": "¿Quieres continuar el pedido?",
  "kioskLanding.inactive.prelude": "El pedido se cancelará automáticamente en",
  "kioskLanding.inactive.cancel": "Cancelar pedido",
  "kioskLanding.inactive.continue": "Continuar",
  "userGreetings.defaultUnAuthenticatedText": "Inicia sesión",
  "userGreetings.defaultAuthenticatedText": "Hola, *|customer_name|*",
  "viewOrder.cashbackSpent": "{{denomination}} gastado",
  "viewOrder.cashbackObtained": "{{denomination}} obtenido",
  "orderRecord.anonOrderText": "Actualización manual",
  "myCashback.historyTitle": "Historial de {{denomination}}",
  "myCashback.denomination": "{{denomination}} actual",
  cashback: n,
  "loginPage.prelude": "Debes estar registrado para ver esta página",
  "loginPage.callToAction": "Haz click aquí para iniciar sesión",
  paymentMethods: i,
  "shopLanding.singleRestaurant.delivery.title": "¿Para cuándo quieres tu pedido?",
  "shopLanding.fetchAction.confirmation.accept": "Aceptar",
  "shopLanding.fetchAction.confirmation.cancel": "Cancelar",
  "shopLanding.fetchAction.confirmation.title": "¿Está seguro?",
  "shopLanding.fetchAction.confirmation.body": "Por favor confirma esta acción",
  "shopLanding.fetchAction.2xx.title": "Éxito",
  "shopLanding.fetchAction.2xx": "{status} Éxito",
  "shopLanding.fetchAction.3xx.title": "Redirigir",
  "shopLanding.fetchAction.3xx": "{status} Redirigir",
  "shopLanding.fetchAction.error.title": "Error",
  "shopLanding.fetchAction.error": "{status} Error",
  "shopLanding.loadingRestaurants": "Preparando locales",
  "shopLanding.book.confirmation.bookingPolicy.label": "Doy mi consentimiento para el tratamiento de datos personales",
  "shopLanding.book.error.text": "Algo salió mal, inténtalo de nuevo más tarde.",
  "shopLanding.book.success.title": "Tu reserva ha sido completada",
  "shopLanding.book.success.text": "Tu reserva ha sido completada",
  "shopLanding.book.confirmation.submit": "Confirmar",
  "shopLanding.book.confirmation.marketing.label": "Acepto recibir promociones de marca en mi correo electrónico",
  "shopLanding.book.confirmation.form.observations.placeholder": "Observaciones",
  "shopLanding.book.confirmation.form.observations.label": "Observaciones",
  "shopLanding.book.confirmation.form.area.placeholder": "Sala 1",
  "shopLanding.book.confirmation.form.area.label": "Seleccione el área",
  "shopLanding.book.confirmation.title": "Confirma tu reserva:",
  "shopLanding.book.listing.submit": "Continuar",
  "shopLanding.book.listing.title": "Reserva en:",
  "shopLanding.book.notMatch.text": "En este momento no podemos ofrecerle ubicaciones que coincidan con sus preferencias.",
  "shopLanding.book.notMatch.title": "No hay localizaciones disponibles",
  "shopLanding.book.reservation.submit": "Encontrar un restaurante",
  "shopLanding.book.reservation.title": "Haz tu reserva",
  "shopLanding.book.nOfPeople": "Nº de personas",
  "shopLanding.book": "Reservar",
  "magiclink.tryAgain": "Reintentar",
  "magiclink.email.code.input": "Introduce el código",
  "magiclink.email.code.try.again": "Empezar de nuevo",
  "magiclink.email.code.continue": "Continuar",
  "magiclink.email.title": "Introduce el código que hemos enviado a tu e-mail",
  "magiclink.email.code.error": "Código no válido",
  "magiclink.email.content": "En breve recibirás en tu correo un enlace de acceso. Si no lo encuentras en tu bandeja de entrada, revisa la carpeta de spam.",
  "payments.engine.7": "Pagar mas tarde",
  "payments.engine.10": "Tarjeta, Apple pay o Google Pay",
  "payments.redirect.verifying": "Procesando el pago…",
  "payments.redirect.errorTitle": "No se ha podido completar el pago.",
  "payments.redirect.error": "Se ha producido un error o el pago ha sido cancelado. Inténtalo de nuevo.",
  "payments.method.5": "Efectivo",
  "payments.method.4": "Bizum",
  "payments.method.3": "Apple pay",
  "payments.method.2": "Google pay",
  "payments.method.1": "Tarjeta de crédito",
  "shopLanding.legal.bookingPolicy": "Política de Reservas",
  "shopLanding.legal.cookiesPolicy": "Política de Cookies",
  "shopLanding.legal.privacyPolicy": "Política de Privacidad",
  "shopLanding.legal.termsAndConditions": "Términos y Condiciones de Compra",
  payLink: r,
  "loyaltyCard.disabled": "La tarjeta de fidelización no está disponible en este momento",
  tier: t,
  points: s,
  loyaltyCard: d,
  vouchers: c,
  "weekdays.short.monday": "Lun",
  "weekdays.short.tuesday": "Mar",
  "weekdays.short.wednesday": "Mier",
  "weekdays.short.thursday": "Jue",
  "weekdays.short.friday": "Vier",
  "weekdays.short.saturday": "Sab",
  "weekdays.short.sunday": "Dom",
  "voucher.expiredBurnBtnText": "Oferta no disponible",
  "voucher.burnBtnText": "Marcar cupón como usado",
  "voucher.terms.scheduleAllDays": "Todos los días",
  "voucher.terms.schedule": "Horario",
  "voucher.terms.usesTimeframe.43200": "usos cada 12 horas",
  "voucher.terms.usesTimeframe.86400": "usos diarios",
  "voucher.terms.usesTimeframe.604800": "usos semanales",
  "voucher.terms.usesTimeframe.2592000": "usos mensuales",
  "voucher.terms.maximum": "Máximo:",
  "voucher.terms.usesTotal": "Usos totales",
  "voucher.terms.usesAndLimitations": "Usos y limitaciones",
  "terms.title": "Términos y Condiciones",
  "voucher.error.noMoreUses": "No quedan usos",
  "voucher.error.outOfSchedule": "Fuera de horario",
  "voucher.error.nextActivation": "Próxima activación",
  "addToWallet.android": "Cartera de Google",
  "addToWallet.apple": "Añadir a Cartera de Apple",
  "voucher.unlimited": "Ilimitado",
  "voucher.validFromTitle": "Válido desde",
  "voucher.validUntilTitle": "Válido hasta",
  "voucher.remainingUsesTitle": "Usos restantes",
  "voucher.pendingValidation": "Cuenta pendiente de verificar",
  "voucher.verify": "Verificar",
  "ticket.placed": "Creado",
  "ticket.followOrderBtn": "Sigue tu pedido",
  discount: l,
  tip: u,
  total: p,
  subtotal: m,
  "order.status.unconfirmed": "No confirmado",
  "order.status.confirmed": "Confirmado",
  "order.status.ready": "Listo",
  "order.status.onroute": "En trayecto",
  "order.status.completed": "Completado",
  "order.status.cancelled": "Cancelado",
  order_delivered: g,
  order_preparation: h,
  order_deliver: v,
  dinein: f,
  takeaway: L,
  loadMore: b,
  "userOrders.heading": "Historial de pedidos",
  "userProfile.emptyTagsText": "¡Aún no tienes ninguna etiqueta! Haz clic aquí para añadir una",
  "gender.male": "Hombre",
  "gender.female": "Mujer",
  "gender.other": "Otro",
  "gender.na": "N/A",
  "userProfile.editInfoHeading": "Edita tu información",
  save: y,
  name: k,
  surname: P,
  email: C,
  birthday: T,
  tags: A,
  gender: E,
  language: x,
  postCode: w,
  "userProfile.navigation.profile": "Perfil",
  "navigation.back": "Atrás",
  "shopLanding.address.error.unknown": "Ha ocurrido un error. Por favor, inténtalo más tarde",
  "shopLanding.address.error.locationTemporarilyUnavailable": "Lo sentimos, este servicio no está disponible en este momento",
  "shopLanding.address.error.addressBothEmpty": "Por favor, rellena los campos dirección y piso/puerta",
  "shopLanding.address.error.addressEmpty": "Por favor, rellena el campo dirección",
  "shopLanding.address.error.addressInfoEmpty": "Por favor, rellena el campo piso/puerta",
  "shopLanding.singleRestaurant.eta.time": "{{time}} min",
  "shopLanding.singleRestaurant.eta": "Tiempo de preparación estimado:",
  "shopLanding.redirection.title": "¡Enhorabuena!",
  "shopLanding.redirection": "Te estamos redirigiendo para que puedas hacer tu pedido",
  "shopLanding.noReach.title": "No llegamos a tu zona",
  testDoNotTouch: "bbb",
  "userMenu.showProfile": "Mostrar perfil",
  "userMenu.logout": "Cerrar sesión",
  "autocomplete.label": "Dirección",
  "autocomplete.placeholder": "Introduce dirección incluyendo número",
  "autocomplete.geolocation": "Usar mi ubicación actual",
  "shopLanding.address.title": "¿Desde dónde pides?",
  "shopLanding.address.label": "Piso, puerta...",
  "shopLanding.address.placeholder": "Especifica la dirección a domicilio o escribe un espacio si no aplica",
  "shopLanding.address.error.suspended": "Lo sentimos, ahora mismo no podemos aceptar más pedidos. Por favor, vuelve a intentarlo en 20 minutos. ¡Muchas gracias!",
  "shopLanding.address.error.outOfRange": "Oops... en este momento no llegamos a tu zona. ¡Puedes hacer un pedido para recoger en tu restaurante más cercano!",
  "shopLanding.address.error.cannotDeliver": "Lo sentimos, en este momento no podemos realizar la entrega en tu dirección. Te recomendamos que hagas tu pedido para recoger.",
  "shopLanding.address.error.invalidAddress": "Lo sentimos, la dirección no es válida. Por favor, compruébala y vuelve a introducirla.",
  "shopLanding.address.error.missingStreet": "Por favor, introduce el número de la calle",
  "shopLanding.address.error.orderThrough": "O pide a través de:",
  "shopLanding.selector.title": "Recoge tu pedido en: ",
  "shopLanding.selector.laterBtn": "Pide para más tarde",
  "shopLanding.selector.nowBtn": "Pide ahora",
  "shopLanding.selector.doOrder": "Hacer pedido",
  "shopLanding.datetime.title": "Elige una hora:",
  "shopLanding.datetime.dayPlaceholder": "Selecciona un día..",
  "shopLanding.datetime.hourPlaceholder": "Selecciona una hora..",
  "shopLanding.datetime.cancelBtn": "Cancelar",
  "shopLanding.datetime.programBtn": "Programar",
  "shopLanding.singleRestaurant.title": "Te atenderá el local:",
  delivery: I,
  pickup: O,
  unknown: S,
  phone: M,
  today: "Hoy",
  tomorrow: V,
  day: "Día",
  hour: R,
  call: D,
  guest: H,
  loginText: N,
  uber: z,
  glovo: G,
  deliveroo: q,
  justeat: F,
  "phoneVerification.title": "Verifica tu número de teléfono",
  "phoneVerification.subtitle": "Recibirás el código por SMS en el número {{phoneNumber}}",
  "phoneVerification.countdown": "Si no llega, puedes solicitar otro código en {{time}}",
  "phoneVerification.resend": "Solicitar otro código",
  "phoneVerification.back": "Atrás",
  "phoneVerification.continue": "Continuar",
  "phoneVerification.error": "Código no válido",
  "phoneVerification.error.invalidCode": "El código introducido no es válido. Inténtalo de nuevo.",
  "phoneVerification.error.expired": "El código ha caducado. Por favor, solicita uno nuevo.",
  "phoneVerification.error.alreadyUsed": "Este código ya ha sido utilizado. Por favor, solicita uno nuevo.",
  "phoneVerification.error.attemptsExceeded": "Demasiados intentos incorrectos. Por favor, solicita un nuevo código.",
  "phoneVerification.error.generic": "Algo ha ido mal. Por favor, inténtalo de nuevo.",
  "phoneInputForm.error.otpRequestCooldown": "Por favor, espera antes de solicitar un nuevo código.",
  "phoneInputForm.error.otpRateLimit": "Demasiadas solicitudes. Por favor, inténtalo más tarde.",
  "phoneInputForm.error.smsProviderError": "No hemos podido enviar el SMS. Por favor, inténtalo de nuevo.",
  "phoneInputForm.title": "Introduce tu número de teléfono",
  "phoneInputForm.phoneLabel": "Teléfono",
  "phoneInputForm.back": "Atrás",
  "phoneInputForm.continue": "Continuar",
  "duplicatePhoneError.title": "Ya existe un usuario con este número vinculado",
  "duplicatePhoneError.subtitle": "El número de teléfono de tu cuenta ya está registrado por otro usuario en la plataforma. Inicia sesión con el email asociado.",
  "duplicatePhoneError.back": "Volver"
};
export {
  T as birthday,
  D as call,
  n as cashback,
  j as day,
  W as default,
  a as defaultFeeName,
  q as deliveroo,
  I as delivery,
  o as deliveryFee,
  f as dinein,
  l as discount,
  C as email,
  E as gender,
  G as glovo,
  H as guest,
  R as hour,
  F as justeat,
  x as language,
  b as loadMore,
  N as loginText,
  d as loyaltyCard,
  k as name,
  v as order_deliver,
  g as order_delivered,
  h as order_preparation,
  r as payLink,
  i as paymentMethods,
  M as phone,
  O as pickup,
  s as points,
  w as postCode,
  y as save,
  e as stampCards,
  m as subtotal,
  P as surname,
  A as tags,
  L as takeaway,
  U as testDoNotTouch,
  t as tier,
  u as tip,
  B as today,
  V as tomorrow,
  p as total,
  z as uber,
  S as unknown,
  c as vouchers
};
//# sourceMappingURL=translation.json.js.map
